import type { FC } from "react"
import React from "react"
import { Stack } from "@chakra-ui/react"
import dynamic from "next/dynamic"

const EditorComp = dynamic(() => import("./mdxeditor/MDXEditorComponent"), {
  ssr: false,
})

type MarkdownEditorProps = {
  placeholder?: string
  value?: string
  onChange: (nextDescription?: string) => void
  onBlur?: (e: FocusEvent) => void
  isInvalid?: boolean
}

const MarkdownEditor: FC<MarkdownEditorProps> = ({
  placeholder,
  value,
  onChange,
  onBlur,
  isInvalid = false,
}) => {
  return (
    <Stack
      borderColor={isInvalid ? "red" : undefined}
      borderWidth={isInvalid ? "2px" : undefined}
      mt={4}
      spacing={3}
    >
      <EditorComp
        markdown={value ?? placeholder ?? ""}
        onBlur={onBlur}
        onChange={onChange}
      />
    </Stack>
  )
}

export default MarkdownEditor
